import { Helmet } from 'react-helmet';
import { IonPhaser } from '@ion-phaser/react';

import MouseInfinityGame from '../../games/MouseInfinity';
import styles from '../../styles/pages/demo/MouseInfinity.module.scss';

const MouseInfinity = () => (
  <div className={styles.mouseInfinity}>
    <Helmet>
      <title>Mouse Infinity - MetaLemon</title>
    </Helmet>
    <IonPhaser game={MouseInfinityGame} />
  </div>
);

export default MouseInfinity;
